<script setup lang="ts">
  const emit = defineEmits(['loadMore', 'post-updated', 'post-removed'])
  import type { Post } from '~~/prisma/generated/client';
  const { posts, loading } = defineProps<{posts: Post[], loading: boolean}>()
function postUpdated(updatedPost: Post) {
  emit('post-updated', updatedPost)
}

function postVisibilityToggle(post: Post) {
  emit('post-updated', {...post, visible: !post.visible})
}
const editPostDialog = ref()

function editPost(post: Post) {
  editPostDialog.value.open(post)
}

function onInfiniScroll(isIntersecting: boolean) {
emit('loadMore', { isIntersecting })
}
</script>

<template>
  <EditPost
    ref="editPostDialog"
    @update="postUpdated"
  />
  <section class="container max-w-80 mt-6 postContainer">
    <Post
      v-for="post in posts"
      :key="post.id"
      card
      :post="post"
      @edit="editPost"
      @remove="emit('post-removed', post)"
      @toggle-visibility="postVisibilityToggle(post)"
      @pin-toggled="emit('post-updated', {...post, pinned: !post.pinned})"
    />
  </section>
  <div
    v-intersect="onInfiniScroll"
    class="pa-1 ma-12 text-center"
  >
    <v-progress-circular
      v-show="loading"
      indeterminate
    />
  </div>
</template>

